import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate, Link } from 'react-router-dom';
import ScrollToTop from './pages/ScrollToTop';

import Home from './pages/Home';
import Header from './Header';
import Batteries from './pages/Batteries';
import VanOperation from './pages/VanOperation';
import Sink from './pages/Sink';
import Toilet from './pages/Toilet';
import AirConditioning from './pages/AirConditioning';
import Cabinets from './pages/Cabinets';
import SwivelSeat from './pages/SwivelSeat';
import InductionStoves from './pages/InductionStoves';
import BugNet from './pages/BugNet';
import WindowCovers from './pages/WindowCovers';
import Footer from './pages/Footer.jsx';
import Shower from './pages/Shower.jsx';

function App() {
  return (
    <div className="App">
      <ScrollToTop />

      <header className="app-header">
        <Header />
      </header>
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/batteries" element={<Batteries />} />
          <Route path="/van-operation" element={<VanOperation />} />
          <Route path="/sink" element={<Sink />} />
          <Route path="/shower" element={<Shower />} />
          <Route path="/toilet" element={<Toilet />} />
          <Route path="/air-conditioning" element={<AirConditioning />} />
          <Route path="/cabinets" element={<Cabinets />} />
          <Route path="/swivel-seat" element={<SwivelSeat />} />
          <Route path="/induction-stoves" element={<InductionStoves />} />
          <Route path="/bug-net" element={<BugNet />} />
          <Route path="/window-covers" element={<WindowCovers />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}

export default function WrappedApp() {
  return (
    <Router>
      <App />
    </Router>
  );
}